export default __webpack_public_path__ + "static/media/album_art.de69719c.png";